import type { WizardStep } from '../../components/BbStepper'

/* The four steps drawn in the batchbooks_export_step_* prototypes. Their own
   stepper art varies between screens (numbered circles, then ticks, then a
   different colour); the import wizard's BbStepper is used throughout instead,
   as requested. */
export const EXPORT_STEPS: WizardStep[] = [
  { key: 'type', label: 'Export Type' },
  { key: 'filters', label: 'Filters' },
  { key: 'fields', label: 'Preview' },
  { key: 'export', label: 'Export' },
]
